import { endpoints, request } from '../..';

export const i18nServices = {
  availableCultures: () => request.get(endpoints.framework('Languages')),
};
